import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../theme/colors';

export const usePercentageBarGridlineStyles = makeStyles<Theme, { color?: string; percentage: number }>(() => ({
  root: {
    backgroundColor({ color = Colors.collectedGreen }) {
      return alpha(color, 0.25);
    },
    width: '100%',
    height: '6px',
    borderRadius: '3px'
  },
  bar: {
    backgroundColor({ color }) {
      return color;
    },
    width({ percentage }) {
      return `${(percentage * 100).toFixed(0)}%`;
    },
    height: '6px',
    borderRadius: '3px'
  }
}));
